module.exports = __webpack_public_path__ + "img/user_interface_design.63a9984f.svg";